import { apiRequest } from "./client";

export interface MockQuestion {
  id: string;
  subject: string;
  stem: string;
  options: Record<string, string> | { id: string; text: string }[] | null;
  topicId: string | null;
}

export interface StartedMock {
  sessionIds: string[];
  durationSeconds: number;
  total: number;
  /** No `correctAnswer` — a mock withholds feedback by design. */
  questions: MockQuestion[];
}

export interface MockSubjectScore {
  subjectId: string;
  subject: string;
  score: number;
  outOf: number;
  correct: number;
  answered: number;
  total: number;
  /** Theory questions the student wrote an answer for but cannot be auto-marked. */
  theoryAnswered: number;
}

export interface MockResult {
  total: number;
  outOf: number;
  subjects: MockSubjectScore[];
  wrongCount: number;
  skippedCount: number;
  /** Theory questions answered but not auto-markable. */
  theoryCount: number;
}

export function startMock(): Promise<StartedMock> {
  return apiRequest<StartedMock>("/api/mock/sessions", {
    method: "POST",
    body: {},
    authenticated: true,
  });
}

export function submitMock(sessionIds: string[]): Promise<MockResult> {
  return apiRequest<MockResult>("/api/mock/sessions/submit", {
    method: "POST",
    body: { sessionIds },
    authenticated: true,
  });
}
